$(document).ready(function () {
    
    $('.toggle-sidebard').click(function(){
        var sidebar = $('.with-sidebard .sidebar'),
            list    = sidebar.find('ul'),
            width   = $(window).width();

        if(width < 769){
            list.stop();
            list.slideToggle(300);
            sidebar.toggleClass('show');
        }
    })

    $('.dashboard-nav .header').click(function(){
        var sidebar = $('.dashboard-nav'),
            list    = sidebar.find('ul'),
            width   = $(window).width();

        if(width < 769){
            list.stop();
            list.slideToggle(300);
            sidebar.toggleClass('show');
        }
    })

});